import React from 'react';
import { Box, Grid, Typography, Stack, Chip } from '@mui/material';
import moment from 'moment';

import { TClassJoinStatusData } from '../../../../helper';

interface ClassJoinTimeStatusViewerPopperComponentProps {
  tutorJoinTime?: number;
  studentJoinTime?: number;
  tutorJoinData?: TClassJoinStatusData;
  studentJoinData?: TClassJoinStatusData;
}

const ClassJoinTimeStatusViewerPopperComponent: React.FC<ClassJoinTimeStatusViewerPopperComponentProps> = ({
  tutorJoinData,
  tutorJoinTime,
  studentJoinData,
  studentJoinTime,
}) => {
  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography fontSize="14px" fontWeight={500}>
                Tutor Joined Time
              </Typography>
              {tutorJoinData ? (
                <Chip
                  size="small"
                  label={tutorJoinData.status}
                  sx={{
                    borderRadius: '5px',
                    backgroundColor: tutorJoinData.chipBg,
                    color: tutorJoinData.chipColor,
                  }}
                />
              ) : null}
            </Stack>
            <Typography fontSize="12px" fontWeight={500} color="#647488">
              {tutorJoinTime
                ? moment(tutorJoinTime).format('ddd MMM DD YYYY hh:mm A')
                : '-'}
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography fontSize="14px" fontWeight={500}>
                Student Joined Time
              </Typography>
              {studentJoinData ? (
                <Chip
                  size="small"
                  label={studentJoinData.status}
                  sx={{
                    borderRadius: '5px',
                    backgroundColor: studentJoinData.chipBg,
                    color: studentJoinData.chipColor,
                  }}
                />
              ) : null}
            </Stack>
            <Typography fontSize="12px" fontWeight={500} color="#647488">
              {studentJoinTime
                ? moment(studentJoinTime).format('ddd MMM DD YYYY hh:mm A')
                : '-'}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ClassJoinTimeStatusViewerPopperComponent;
